import Swal from "sweetalert2";
import $axios from "../../api";

const state = {
  isLoading: false,
  createLoading: false,
  errors: null,
  isSuccess: false,
  notificationList: [],
  page: 1,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.notificationList = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
};

const actions = {
  /* =========================
   * GET LIST
   * ========================= */
  getNotificationList({ commit, state, rootState, dispatch }, payload = "") {
    commit("SET_LOADING", true);

    return $axios
      .get(
        `website/notification/member/list?page=${state.page}&view=${rootState.Main.view}${payload}`
      )
      .then((res) => {
        commit("SET_LIST", res.data.data);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        commit("SET_LOADING", false);
        dispatch(
          "Main/globalSweetAlert",
          err.response,
          { root: true }
        );
      });
  },

  /* =========================
   * AUDIENCE DIMENSIONS (Store & Category)
   * =========================
   * Key setiap opsi sudah di-slug di server (OnesignalSeedUsers::slugTag) supaya
   * hanya ada SATU implementasi slug. Dulu daftarnya di-hardcode di index.vue dan
   * langsung melenceng dari members_tags_master begitu toko baru dibuka.
   * Gagal → kembalikan {} sehingga dimensinya kosong; lebih baik tak ada pilihan
   * daripada pilihan yang tak akan mengenai siapa pun. */
  getAudienceDimensions() {
    return $axios
      .get(`website/notification/member/audience-dimensions`)
      .then((res) => res.data?.data || {})
      .catch(() => ({}));
  },

  /* =========================
   * CREATE
   * ========================= */
  createNotification({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    commit("SET_ERRORS", null);

    return $axios
      .post(`website/notification/member/create`, payload)
      .then((res) => {
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", true);

        // Push bisa "berhasil" di level HTTP tapi mengenai 0 subscription (semua
        // penerima cuma punya subscription Email). Server menandainya lewat
        // push_warning — tampilkan apa adanya, jangan sebagai sukses biasa.
        if (res.data?.push_warning) {
          // Pesan dari server sudah singkat dan jelas; jangan tambahi judul yang
          // mengulanginya.
          Swal.fire({
            icon: "warning",
            html: `<p class="font-size-110rem mb-0">${res.data.message}</p>`,
          });
          return;
        }

        dispatch(
          "Main/globalSuccessSweetAlert",
          res.data?.message || "Data successfully created",
          { root: true }
        );
      })
      .catch((err) => {
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", false);
        commit("SET_ERRORS", err.response?.data?.errors || err);
        dispatch(
          "Main/globalSweetAlert",
          err.response,
          { root: true }
        );
      });
  },

  /* =========================
   * SHOW / HIDE
   * ========================= */
  showhide({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_LOADING", true);

    return $axios
      .post(`website/notification/member/showhide`, { id: payload })
      .then((res) => {
        commit("SET_LOADING", false);
        commit("SET_SUCCESS", true);
        dispatch(
          "Main/globalSuccessSweetAlert",
          res.data.message || "Success",
          { root: true }
        );
      })
      .catch((err) => {
        commit("SET_LOADING", false);
        commit("SET_SUCCESS", false);
        dispatch(
          "Main/globalSweetAlert",
          err.response,
          { root: true }
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
